<template>
  <main-layout>

    <div slot="sidebar" class="site-box">
      <category-list v-bind:category="this.$store.state.guideList" v-bind:groupId="groupId"></category-list>
    </div>

    <div slot="content" class="site-box">
        <h2 class="title">{{title}}</h2>
        <div class="markdown-container">
          <vue-markdown :source="markdown"></vue-markdown>
        </div>
        <scroll-nav v-bind:scrollList="scrollList"></scroll-nav>
    </div>

  </main-layout>
</template>

<style lang="scss" rel="stylesheet/scss">
  @import '../../../../node_modules/prismjs/themes/prism.css';
  @media screen and (max-width: 1400px){
    .markdown-container{
      width: 700px;
    }
  }
  .markdown-container{
    a{
      color: #00a6ff;
    }
    table{
      td{
        border: 1px solid #ddd;
        padding: 5px;
      }
    }
  }
  blockquote{
    margin: 0;
    padding: 0 1em;
    color: #6a737d;
    border-left: 0.25em solid #dfe2e5;
    code{
      padding: 0.2em 0.4em;
      margin: 0;
      font-size: 85%;
      background-color: rgba(27,31,35,0.05);
      border-radius: 3px;
    }
  }
  pre{
    padding: 16px;
    overflow: auto;
    line-height: 1.45;
    background-color: #f6f8fa;
    border-radius: 3px;
  }
  tr{
    &:nth-child(odd){
      background-color: #f9f9f9;
    }
    &:nth-child(even){
      background-color: #fff;
    }
  }
</style>
<script>
  /* eslint-disable */
  import VueMarkdown from 'vue-markdown';
  import 'prismjs';
  import CategoryList from '../components/CategoryList';
  import ScrollNav from '../components/ScrollNav';
  import MainLayout from '../../../layouts/MainLayout';

  export default {
    components: {
      MainLayout,
      VueMarkdown,
      CategoryList,
      ScrollNav,
    },
    data() {
      return {
        title:'',
        markdown: '',
        groupId: '',
        itemId: '',
        scrollList:[],
      };
    },
    mounted() {
      const params = this.$route.params;
      const groupId = params.category_id;
      const itemId = params.post_id;
      this.groupId = groupId;
      this.itemId = itemId;
      this.fetchMarkdown();
      //this.$parent.breadcrumbList[0].to = `/${this.$route.params.language}/detail`;
    },

    methods: {
      fetchMarkdown() {
        const params = this.$route.params;
        const groupId = params.category_id;
        const itemId = params.post_id;
        this.$http.get(`${process.env.API_URL}/${this.$route.params.language}/guide/article/2/${itemId}`).then((res) => {
          if(res.body.code == 200000){
            this.markdown = res.body.data.text;
            this.title = res.body.data.title;
            this.$nextTick(()=>{
              this.initScroll();
              Prism.highlightAll()
            })
          }else{
            this.markdown = '查询失败';
          }
        }, (res) => {
          this.markdown = 'error';
          this.title = 'error';
        });
      },
      initScroll(e){
        if(this.$route.params.category_id.length > 0){
          var list = [];
          var links = document.querySelectorAll('.markdown-container h4,.markdown-container h5');
          links.forEach((item)=>{
            var obj = {
              ele: item,
              title : item.innerText,
              type: item.tagName,
              offsetTop:item.offsetTop
            }
            list.push(obj);
          })
          this.scrollList = list;
        }
      },
    },
    watch: {
      '$route':'fetchMarkdown'
    },
  };
</script>



// WEBPACK FOOTER //
// Detail.vue?0d81f481